import * as PIXI from "pixi.js";

import { TGameAssetAlias } from "@src/game/screens/GameScreen";
import { IView } from "@src/core/game/components/IView";
import { Assets } from "@src/core/assets/Assets";
import { Audio } from "@src/core/audio/Audio";

export class FreespinCounterView implements IView {
  private _view: PIXI.Container = new PIXI.Container();
  public get view(): PIXI.Container {
    return this._view;
  }

  private _panel!: PIXI.Sprite;

  private _counterText!: PIXI.Text;
  private _counterTextStyle: PIXI.TextStyle = new PIXI.TextStyle({
    fontSize: 220,
    fontFamily: "gameFont",
    align: "center",
    wordWrap: false,
    wordWrapWidth: 700,
    fill: 0xffbb1e,
    stroke: {
      color: 0x000000,
      width: 12,
      join: "round",
    },
    letterSpacing: 0,
    lineHeight: 38,
    padding: 4,
  });

  public constructor() {
    this._initializeAssets();
    this._parentAssets();

    this._initializeComponents();
    this._parentComponents();
  }

  public setCounterText(freespinCountText: string, skipAudio: boolean = false): void {
    if (this._counterText.text !== freespinCountText && !skipAudio) {
      Audio.play("sndCounterValueChange");
    }

    this._counterText.text = freespinCountText;
  }

  private _initializeAssets(): void {
    const gameAtlasSpritesheet1 =
      Assets.getAsset<TGameAssetAlias>("atlasGame1");

    this._panel = new PIXI.Sprite(
      gameAtlasSpritesheet1.textures["fs_panel_info.webp"],
    );
    this._panel.anchor.set(0.5);
  }

  private _parentAssets(): void {
    this.view.addChild(this._panel);
  }

  private _initializeComponents(): void {
    this._counterText = new PIXI.Text({
      text: "10",
      style: this._counterTextStyle,
    });
    this._counterText.anchor.set(0.5);
  }

  private _parentComponents(): void {
    this.view.addChild(this._panel);
    this.view.addChild(this._counterText);
  }
}
